module.exports = __webpack_public_path__ + "static/media/web-programming.02fc4612.svg";